// OptionalDocumentsForm.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LeadForm.css'; // Reuse the same CSS
import Loader from './Loader';
import { useLocation, useNavigate } from 'react-router-dom';

const OptionalDocumentsForm = () => {
  const axiosDomain = process.env.REACT_APP_AXIOS_DOMAIN;
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('tk');
  
  if (!token) {
    navigate('/login');
  }
  const [formData, setFormData] = useState({
    documents: [null, null, null],
    document_types: ['', '', ''],
    expiryDates: ['', '', ''],
    caseId: '',
    last_name: '',
    //addcases: [],
    //addlenders: [],
    //POI_req: '',
    //POA_req: '',
    otherName: '',
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  // const [poiSelected, setPOISelected] = useState('');
  // const [poaSelected, setPOASelected] = useState('');
  const [otherSelected, setOtherSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {        
    const fetchData = async () => {
      try {                
        const response = await axios.post(`${axiosDomain}/api/leads/retrieve-details?token=${token}`);
        if (response.status !== 200) {
          throw new Error('Failed to fetch data');
        }
        const data = response.data;
        if (data.action === 'go to submission') {
          navigate('/?tk=' + token);
          return;
        }
        if (data.action === 'already submitted') {
          setError('You have already completed your submission');
          return;
        }
        if (data.action === 'continue') {
          setFormData({
            ...formData,
            caseId: data.caseId,
            last_name: data.last_name,
            lender: data.lender
          });
        }                
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e, index) => {
    const { name, value, files } = e.target;
    const newDocuments = [...formData.documents];
    const docTypes = [...formData.document_types];
    const expiryDates = [...formData.expiryDates];

    if (name === 'documents') {
      newDocuments[index] = files[0];
    } else if (name === 'doc_selection') {
      docTypes[index] = value;
    } else if (name === 'expiry_date') {
      expiryDates[index] = value;
    }

    setFormData({
      ...formData,
      documents: newDocuments,
      document_types: docTypes,
      expiryDates: expiryDates,
    });

    if (index === 2 && value === 'Other') {
      setOtherSelected(true);
    } else if (index === 2) {
      setOtherSelected(false);
    }
  };

  const handleOtherNameChange = (e) => {
    setFormData({
      ...formData,
      otherName: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    // if (formData.POI_req === 1 && (!formData.documents[0] || !formData.document_types[0])) {
    //   setError('Please provide POI document and select its type.');
    //   return;
    // }
    // if (formData.POA_req === 1 && (!formData.documents[1] || !formData.document_types[1])) {
    //   setError('Please provide POA document and select its type.');
    //   return;
    // }

    if (formData.documents[2] && !formData.document_types[2]) {
      setError('Please select a document type for the "Other" document.');
      return;
    }
    if (formData.document_types[2] === 'Other' && !formData.otherName) {
      setError('Please specify the document type for "Other".');
      return;
    }

    // Validate expiry dates
    for (let i = 0; i < formData.document_types.length; i++) {
      const docType = formData.document_types[i];
      if ((docType === 'Passport' || docType === 'Driving Licence') && !formData.expiryDates[i]) {
        setError(`Please provide an expiry date for your ${docType}.`);
        return;
      }
      const today = new Date();
      const minExpiryDate = new Date(today.setMonth(today.getMonth() + 1));
      const selectedDate = new Date(formData.expiryDates[i]);
      if (selectedDate < minExpiryDate) {
        setError(`The expiry date for your ${docType} must be at least one month from today.`);
        return;
      }
    }

    setIsLoading(true);
    const data = new FormData();
    data.append('caseId', formData.caseId);    
    data.append('last_name', formData.last_name);
    data.append('lender', formData.lender);
    data.append('newcaseId', formData.caseId);
    data.append('selectedLender', formData.lender);
    // data.append('addcases', JSON.stringify(formData.addcases));
    // data.append('addlenders', JSON.stringify(formData.addlenders));

    formData.documents.forEach((document, index) => {
      if (document) {
        const docType = formData.document_types[index];
        const extension = document.name.slice(document.name.lastIndexOf('.'));
        const fileName = `${docType}_${index + 1}${extension}`;
        data.append('documents', document, fileName);
      }
    });

    try {
      const response = await axios.post(`${axiosDomain}/api/leads/submitOptionalDocuments?token=${token}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message);
      setIsLoading(false);
      setError('');
      navigate('/thankyou');
    } catch (err) {
      setError('Submission failed: ' + err.message);
      setIsLoading(false);
    }
  };

  if (error) {
    return (
      <div className="login-form">
        {error}
      </div>
    );
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="form-container">
          <h2>Optional Documents Submission</h2>
          <form onSubmit={handleSubmit}>
            
              <div className="upload-section">
                <h3>Upload POI Document<span className="docstar">*</span></h3>
                <strong>Proof of Identity</strong><br/>
                (Ideal forms of Proof of Identity are: a copy of your current signed passport or current UK photo card driving licence.)
                <div className="form-group">
                  <label>Select Document Type</label>
                  <select name="doc_selection" defaultValue="" onChange={(e) => handleChange(e, 0)}>
                    <option value="" disabled>Select Document Type</option>
                    <option value="Passport">Passport</option>
                    <option value="Driving Licence">Driving Licence</option>
                  </select>
                  <input
                    type="file"
                    name="documents"
                    onChange={(e) => handleChange(e, 0)}
                    required
                  />
                  {(formData.document_types[0] === 'Passport' || formData.document_types[0] === 'Driving Licence') && (
                    <div className="form-group">
                      <label>Expiry Date<span className="docstar">*</span>:</label>
                      <input
                        type="date"
                        name="expiry_date"
                        value={formData.expiryDates[0]}
                        onChange={(e) => handleChange(e, 0)}
                        required
                      />
                    </div>
                  )}
                </div>
                <br/>
                <span className="important-note-poi">*Please ensure that your name on the uploaded document matches the one in our system (on your LOA).</span>
                <br/>
                <span className="important-note-poi">*Please ensure that the uploaded document has not expired.</span>
              </div>
            
            <div className="border-div"></div>
            
              <div className="upload-section">
                <h3>Upload POA Document<span className="docstar">*</span></h3>
                <strong>Proof of Address</strong><br/>
                Examples of acceptable forms of proof of address are:
                <br/><br/>
                <ul>
                  <li>A Utility Bill  (dated within the last three months)</li>
                  <li>A Bank Statement  (dated within the last three months)</li>                    
                  <li>A Mortgage Statement (dated within the last 12 months)</li>
                  <li>A Council Tax Bill or Payment Book (dated within the last 12 months)</li>
                </ul>
                <div className="form-group">
                  <label>Select Document Type</label>
                  <select name="doc_selection" defaultValue="" onChange={(e) => handleChange(e, 1)}>
                    <option value="" disabled>Select Document Type</option>
                    <option value="Utility Bill">Utility Bill</option>
                    <option value="Bank Statement">Bank Statement</option>                        
                    <option value="Mortgage Statement">Mortgage Statement</option>
                    <option value="Council Tax Bill">Council Tax Bill</option>                    
                  </select>
                  <input
                    type="file"
                    name="documents"
                    onChange={(e) => handleChange(e, 1)}
                    required
                  />
                </div>
                <br/>
                <span className="important-note-poi">*Please ensure that your name on the uploaded document matches the one in our system (on your LOA).</span>
                <br/>
                <span className="important-note-poi">*Please ensure that the uploaded document has not expired.</span>
                <br/>
                <span className="important-note-poi">*The address on the document should be the same as the one in our system (on your LOA).</span>
              </div>
            
            <div className="border-div"></div>
            <div className="upload-section">
              <h3>Upload Other Document</h3>
              <span className="important-note">This is the most valuable information that can be provided to us, so we ask that you please take the time to have a thorough search of any records you may have.<br/><br/></span>
              For the optional additional documents that may provide evidence of account:
              <br/><br/>
              Please upload here any other documentation that may be beneficial in assisting your
              lender to trace your account(s), for example a letter / communication from your 
              lender which details an account number.
              <div className="form-group">
                <label>Select Other Document Type</label>
                <select name="doc_selection" defaultValue="" onChange={(e) => handleChange(e, 2)}>
                  <option value="" disabled>Select Document Type</option>
                  <option value="Passport">Passport</option>
                  <option value="Driving Licence">Driving Licence</option>
                  <option value="Utility Bill">Utility Bill</option>
                  <option value="Bank Statement">Bank Statement</option>
                  <option value="Credit Card Statement">Credit Card Statement</option>
                  <option value="Mortgage Statement">Mortgage Statement</option>
                  <option value="Council Tax Bill">Council Tax Bill</option>
                  <option value="Other">Other</option>
                </select>
                {otherSelected && (
                  <input type="text" name="other_name" value={formData.otherName} onChange={handleOtherNameChange} />
                )}
                <input
                  type="file"
                  name="documents"
                  onChange={(e) => handleChange(e, 2)}
                />
                {(formData.document_types[2] === 'Passport' || formData.document_types[2] === 'Driving Licence') && (
                    <div className="form-group">
                      <label>Expiry Date<span className="docstar">*</span>:</label>
                      <input
                        type="date"
                        name="expiry_date"
                        value={formData.expiryDates[2]}
                        onChange={(e) => handleChange(e, 2)}
                        required
                      />
                    </div>
                  )}


              </div>
              <br/><br/>
              If you are unsure of what documentation you should upload please contact our Customer
              Service Team by email on assistance@claimlion.com or by calling (0)800 599 9993.
            </div>
            <div className="form-buttons">
              <button type="submit">Submit</button>            
              <button onClick={console.log('button clicked')} className="skip-button">Skip Optional Documents</button>
            </div>
            {message && <p className="message success">{message}</p>}
            {error && <p className="message error">{error}</p>}
          </form>
            
        </div>
      )}
    </>
  );
};

export default OptionalDocumentsForm;
